import {
    E_RISK_TYPE,
    IActiveClientFacingIndicator,
    IActiveContingentRisk,
    IActiveDimension,
} from 'interfaces';
import rootStore from 'RootStore';

export const RISK_TYPE_TO_LABEL = {
    [E_RISK_TYPE.CLIENT_FACING_INDICATORS]: 'Focus',
    [E_RISK_TYPE.DIMENSIONS]: 'Fundamentals',
    [E_RISK_TYPE.CONTINGENT]: 'Bilateral',
};


export const getContingentRiskName = (dimension: IActiveContingentRisk) => {
    return dimension?.name;
};
export const getDimensionLongName = (dimension: IActiveDimension) => {
    return dimension?.lname;
};

export const getDimensionShortName = (dimension: IActiveDimension) => {
    return dimension?.sname;
};

export const getCFILongName = (cfi: IActiveClientFacingIndicator) => {
    return cfi?.display_name;
};

export const getCFIShortName = (cfi: IActiveClientFacingIndicator) => {
    return cfi?.abbreviation;
};

export const getRiskShortName = (type: E_RISK_TYPE, id: number) => {
    switch (type) {
        case E_RISK_TYPE.DIMENSIONS:
            return getDimensionShortName(
                rootStore.risksStore.dimensions.hashed[id]
            );
        case E_RISK_TYPE.CLIENT_FACING_INDICATORS:
            return getCFIShortName(
                rootStore.risksStore.clientFacingIndicators[id]
            );
        case E_RISK_TYPE.CONTINGENT:
            return getContingentRiskName(
                rootStore.risksStore.contingentRisks.find(cr => cr.id === id)
            );
        default:
            return null;
    }
};

export const getRiskLongName = (type: E_RISK_TYPE, id: number) => {
    switch (type) {
        case E_RISK_TYPE.DIMENSIONS:
            return getDimensionLongName(
                rootStore.risksStore.dimensions.hashed[id]
            );
        case E_RISK_TYPE.CLIENT_FACING_INDICATORS:
            return getCFILongName(
                rootStore.risksStore.clientFacingIndicators[id]
            );
        case E_RISK_TYPE.CONTINGENT:
            return getContingentRiskName(
                rootStore.risksStore.contingentRisks.find(cr => cr.id === id)
            );
        default:
            return null;
    }
};
